var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1734504011414,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 15711,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 701.952V896h-128v-194.048h-128l193.504-215.552L704 701.952h-128z",
    fill: "#82A5FE",
    "p-id": 15712
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1024 626.272c0 143.68-103.616 264.032-240.48 269.568h-67.872v-128l65.28 0.064c62.4-2.56 115.104-63.744 115.104-141.632 0-79.808-55.168-141.728-119.264-141.728a102.4 102.4 0 0 0-14.4 1.024l-63.328 9.088-9.12-63.328c-14.624-101.792-90.912-175.36-177.888-175.36s-163.232 73.568-177.888 175.36l-9.12 63.328-63.328-9.088a102.4 102.4 0 0 0-14.4-1.024c-64.128 0-119.264 61.92-119.264 141.728 0 77.888 52.704 139.136 112.352 141.728l67.872-0.128 0.256 128-70.72 0.096C103.584 890.304 0 769.952 0 626.304c0-137.472 94.752-253.088 219.68-268.064C260.8 224.064 376.192 128.032 512 128.032s251.2 96.032 292.32 230.208C929.28 373.216 1024 488.832 1024 626.304z",
    fill: "#2E68F8",
    "p-id": 15713
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackup);
export default __webpack_public_path__ + "static/media/backup.b4ad01133c06c6fa58967a8dfd52f12a.svg";
export { ForwardRef as ReactComponent };